import { history, msgTypes, login as loginUtil, showModal } from "@utils";
import { authConstants } from "@constants";
import { secureStroge, storgeKeys } from "@utils";
import { authService } from "@services";
import { maskActions } from "@actions";

export const authActions = {
  /**
   * Execute Login.
   * @param {string} constructionUuid - The uuid of construction.
   * @param {string} password - The password of user.
   * @description Contains user identity settings.
   */
  login(constructionUuid, password, token, errorCb) {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      authService
        .login(constructionUuid, password, token)
        .then(
          userInfo => {
            dispatch({
              type: authConstants.LOGIN_SUCCESS,
              userInfo
            });
            loginUtil.goRedirectPage(history);
          },
          err => {
            const { message, data } = err;
            showModal(msgTypes.ERROR, "錯誤", message);
            dispatch({
              type: authConstants.LOGIN_FAILURE
            });

            errorCb && errorCb(data || 0);
          }
        )
        .then(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * Check the validity of the login credentials.
   * @description Contains user identity settings.
   */
  check(toLogin) {
    const gotoLoginPage = constructionUuid => {
      if (toLogin && typeof toLogin === "function") {
        toLogin(constructionUuid);
      } else {
        history.push(`/Login/${constructionUuid ? constructionUuid : ""}`);
      }
    };
    const userCredential = secureStroge.get(storgeKeys.userCredential);
    if (userCredential) {
      return dispatch => {
        dispatch(maskActions.toggleMask(true));
        authService
          .check(userCredential.uuid)
          .then(
            userInfo => {
              dispatch({
                type: authConstants.LOGIN_SUCCESS,
                userInfo
              });
            },
            error => {
              // 使用者驗證失敗
              if (error.status === 400) {
                dispatch({
                  type: authConstants.LOGIN_FAILURE
                });
                setTimeout(() => {
                  gotoLoginPage(userCredential.uuid);
                }, 200);
              }
            }
          )
          .then(() => {
            dispatch(maskActions.toggleMask(false));
          });
      };
    }
    gotoLoginPage();
    return { type: authConstants.LOGIN_FAILURE };
  },
  /**
   * Execute Logout.
   */
  logout(constructionUuid) {
    history.push(`/Login/${constructionUuid}`);
    return { type: authConstants.LOGOUT };
  }
};
